// Single source of truth for the HR-portal split.
//
// The HR portal (hr.feelixconnection.com) is a separate build of this same
// app, produced by `npm run build:hr` (sets REACT_APP_SITE=hr, see
// package.json). That env var is inlined at build time, so branches on
// IS_HR_SITE below are dead-code-eliminated out of whichever bundle doesn't
// need them.
export const SITE = process.env.REACT_APP_SITE === "hr" ? "hr" : "main";
export const IS_HR_SITE = SITE === "hr";

const HR_ROLE = "hr";

export function isHrRole(role) {
  return typeof role === "string" && role.trim().toLowerCase() === HR_ROLE;
}

// Where an HR admin lands after login, and the fallback for any URL the HR
// build doesn't have a route for.
export const HR_DEFAULT_ROUTE = "/dashboard/user-management/users-list";

// Default landing route for the main (non-HR) build.
export const MAIN_DEFAULT_ROUTE = "/dashboard/analytics";

export const DEFAULT_ROUTE = IS_HR_SITE ? HR_DEFAULT_ROUTE : MAIN_DEFAULT_ROUTE;
